import React from "react";
import SVG from "react-inlinesvg";
import {toAbsoluteUrl} from "../../../../_helpers";

const Actions = ({children}) => {
    return (
        <div className="topbar">
            <div className={`topbar-item mr-2`}>
                <div id="od_aside_toggle"
                     className="btn btn-icon btn-icon-mobile w-auto btn-topbar d-flex align-items-center btn-lg waves-effect waves-light"
                     style={{
                         height: 'calc(1.0em + 1.65rem + 2px)',
                         padding: '0 0.45rem'
                     }}>
                    <span className="svg-icon svg-icon-white svg-icon-2x">
                        <SVG title={`Toggle menu`}
                             src={toAbsoluteUrl("/media/svg/icons/Layout/Layout-left-panel-2.svg")}/>
                    </span>
                </div>
            </div>

            {children}
        </div>
    );
}

export default Actions;
